import { signOut } from 'aws-amplify/auth';

import { AUTH_LOGIN } from '../constants/action-types';

export const failedAuthLogin = () => {
  return {
    type: AUTH_LOGIN,
    isAuthenticated: false,
  };
};

export function authLogout() {
  return function (dispatch: any) {
    signOut().then((data) => {
      dispatch(failedAuthLogin());
      window.location.href = '/';
    });
  };
}
